import { Injectable } from '@angular/core';
import { ICompany, ISaveCompany } from 'projects/shared/src/lib/@ngrx/company/company.model';
import { BaseGatewayService } from 'projects/shared/src/lib/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingCompanyService extends BaseGatewayService {
  protected override baseURL = `v1/onboarding/company/`;

  create(data: ISaveCompany) {
    return this.post<ICompany>(data);
  }
}
